"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SideNavigation;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.regexp.to-string.js");

var _SideNavigationModule = _interopRequireDefault(require("../../assets/styles/components/SideNavigation.module.scss"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SideNavigation(_ref) {
  let {
    value = "",
    fixed = false,
    items = {},
    onChange,
    onMinimize,
    styling = {},
    iconsOnly = false,
    minimizable = false
  } = _ref;
  const [nav, setnav] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    setnav(items);
  }, [items]);
  const [opened_subpage, setopened_subpage] = (0, _react.useState)(null);
  const [open_navigation, setopen_navigation] = (0, _react.useState)(false);
  const [minimize_navigation, setminimize_navigation] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setminimize_navigation(iconsOnly);
  }, [iconsOnly]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "".concat(_SideNavigationModule.default.mobile_header, " ").concat(fixed && _SideNavigationModule.default.fixed),
      children: [nav.header && nav.header, /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: () => {
          onMinimize(!open_navigation);
          setopen_navigation(!open_navigation);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
          viewBox: "0 0 24 24",
          width: "24",
          height: "24",
          stroke: "currentColor",
          strokeWidth: "2",
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
            x1: "3",
            y1: "12",
            x2: "21",
            y2: "12"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
            x1: "3",
            y1: "6",
            x2: "21",
            y2: "6"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
            x1: "3",
            y1: "18",
            x2: "21",
            y2: "18"
          })]
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "".concat(_SideNavigationModule.default.navigation, " ").concat(!open_navigation && _SideNavigationModule.default.close_navigation, " ").concat(minimize_navigation && _SideNavigationModule.default.minimize_navigation, " ").concat(fixed && _SideNavigationModule.default.fixed),
      style: styling,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
        className: _SideNavigationModule.default.top,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _SideNavigationModule.default.header,
          children: [nav.header, !iconsOnly && minimizable && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => {
              setopened_subpage(null);
              onMinimize(!minimize_navigation);
              setminimize_navigation(!minimize_navigation);
            },
            className: "".concat(_SideNavigationModule.default.minimize_btn, " ").concat(minimize_navigation && _SideNavigationModule.default.minimize_btn_open),
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
              viewBox: "0 0 24 24",
              width: "24",
              height: "24",
              stroke: "currentColor",
              strokeWidth: "1.5",
              fill: "none",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
                points: "11 17 6 12 11 7"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
                points: "18 17 13 12 18 7"
              })]
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _SideNavigationModule.default.body,
          children: nav.body && Object.keys(nav.body).map((v, i) => {
            if (nav.body[v].active) {
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: _SideNavigationModule.default.p_o_c,
                children: [minimize_navigation && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: _SideNavigationModule.default.tooltip,
                  children: v
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: _SideNavigationModule.default.page_option_container,
                  onClick: () => {
                    if (opened_subpage !== v.toLowerCase() && opened_subpage) {
                      setopened_subpage(null);
                    }

                    onChange(v, "mainpage");
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "".concat(_SideNavigationModule.default.page_option, " ").concat(opened_subpage === v.toLowerCase() && _SideNavigationModule.default.opened_page_option, " ").concat(value.toString().toLowerCase() === v.toLowerCase() && _SideNavigationModule.default.active_page),
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      className: _SideNavigationModule.default.page_option_content,
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        className: _SideNavigationModule.default.page_icon,
                        children: nav.body[v].icon
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                        className: _SideNavigationModule.default.page_link,
                        children: v
                      })]
                    }), Array.isArray(nav.body[v].subpages) && nav.body[v].subpages.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                      className: _SideNavigationModule.default.open_page_btn,
                      onClick: () => {
                        if (opened_subpage === v.toLowerCase()) {
                          setopened_subpage(null);
                        } else {
                          setopened_subpage(v.toLowerCase());
                        }
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
                        className: _SideNavigationModule.default.open_page_arrow,
                        viewBox: "0 0 24 24",
                        width: "24",
                        height: "24",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
                          points: "6 9 12 15 18 9"
                        })
                      })
                    })]
                  }), Array.isArray(nav.body[v].subpages) && nav.body[v].subpages.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "".concat(_SideNavigationModule.default.subpages, " ").concat(opened_subpage === v.toLowerCase() && _SideNavigationModule.default.opened_subpages),
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
                      className: _SideNavigationModule.default.subpage_line_ct,
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        className: _SideNavigationModule.default.subpages_line
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      className: _SideNavigationModule.default.subpages_column,
                      children: nav.body[v].subpages.map((v_sb, i_sb) => {
                        return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                          onClick: () => {
                            onChange(v_sb, "subpage");
                          },
                          className: "".concat(_SideNavigationModule.default.subpage_option, " ").concat(_SideNavigationModule.default.page_link),
                          children: v_sb
                        }, i_sb);
                      })
                    })]
                  })]
                })]
              }, i);
            }
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
        className: _SideNavigationModule.default.footer,
        children: nav.footer && nav.footer.logout && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "".concat(_SideNavigationModule.default.page_option_content, " ").concat(_SideNavigationModule.default.logout_option),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _SideNavigationModule.default.page_icon,
            children: nav.footer.logout.icon
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: _SideNavigationModule.default.page_link,
            children: nav.footer.logout.text
          })]
        })
      })]
    })]
  });
}